<template>
    <div v-if="hasErrors" class="fixed right-2 top-3 bg-yellow-500 text-pink-800 z-10 max-w-2xl py-3 px-5 rounded">
        Oops! Algo deu errado.

        <ul class="mt-3 list-disc list-inside text-sm">
            <li v-for="(error, key) in this.computedErrors" :key="key">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        errors: Array
    },
    computed: {
        computedErrors() {
            return this.errors
        },
        hasErrors() {
            return Object.keys(this.errors).length > 0
        },
    }
}
</script>
